/** @jsx h */
import { labels } from '../config';
import { useRef, useEffect, useState } from 'preact/hooks';

const SearchHeader = ({ query, pluginNamespace }) => {
  const [searchQuery, setSearchQuery] = useState(query);
  const searchInputEl = useRef(null);

  useEffect(() => setSearchQuery(query), [query]);

  function handleInputChange() {
    if (searchInputEl && searchInputEl.current) {
      const value = searchInputEl.current.value;
      setSearchQuery(value);
    }
  }

  function resetQuery() {
    setSearchQuery('');
  }

  return (
    <div className="searchbar searchbar--large">
      <div className="searchbar__wrapper">
        <label htmlFor="search-input" className="sr-only">
          {labels.search.placeholder}
        </label>
        <input
          id="search-input"
          className="searchbar__input"
          data-main-input
          name={`${pluginNamespace}[q]`}
          value={searchQuery}
          ref={searchInputEl}
          onChange={handleInputChange}
          autocomplete="off"
          placeholder={labels.search.placeholder || ''}
          type="text"
          aria-label={labels.search.placeholder}
        />
        {searchQuery ? (
          <button
            type="button"
            className="search__button btn btn--icon"
            onClick={resetQuery}
          >
            <span className="sr-only">{labels.faceting.resetQuery}</span>
            <svg
              class="svg-close"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 80 80"
              aria-hidden="true"
            >
              <defs>
                <style>.cls-1 {`fill-rule: evenodd;`}</style>
              </defs>
              <polygon
                fill="currentColor"
                class="cls-1"
                points="80 5 75 0 40 35 5 0 0 5 35 40 0 75 5 80 40 45 75 80 80 75 45 40 80 5"
              />
            </svg>
          </button>
        ) : (
          ''
        )}
        <button
          type="submit"
          className="searchbar__button btn btn--large btn--icon"
        >
          <span className="sr-only">{labels.search.submit}</span>
          <svg
            className="svg-search"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 80 80"
            aria-hidden="true"
          >
            <defs>
              <style>.cls-1{`fill-rule:evenodd;`}</style>
            </defs>
            <path
              fill="currentColor"
              className="cls-1"
              d="m80,72.89l-19.47-19.47c4.11-5.57,6.55-12.44,6.55-19.88C67.08,15.05,52.03,0,33.54,0S0,15.05,0,33.54s15.05,33.54,33.54,33.54c7.44,0,14.31-2.44,19.88-6.55l19.47,19.47,7.11-7.11ZM10.05,33.54c0-12.95,10.54-23.48,23.48-23.48s23.48,10.53,23.48,23.48-10.53,23.48-23.48,23.48-23.48-10.53-23.48-23.48Z"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default SearchHeader;
